import { PlaylistAdd } from "@mui/icons-material";
import { Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { StationHubItemEdit } from "./station-hub-item.edit";
import { IStationHubItem } from "./table-station-hub.models";

interface IStationHubItemAddProps {
  existingItems?: IStationHubItem[];
  currentStationId?: number;
  onAdded: (value: IStationHubItem) => void;
  onEditStart?: () => void;
  onEditEnd?: () => void;
}

export const StationHubItemAdd: FC<IStationHubItemAddProps> = ({
  existingItems = [],
  currentStationId,
  onAdded,
  onEditStart,
  onEditEnd,
}) => {
  const { t } = useTranslation();
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);

  useEffect(() => {
    if (isAddNewOpened) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [isAddNewOpened, onEditStart, onEditEnd]);

  const handleAddNewClose = useEvent(() => {
    setAddNewOpenedState(false);
  });

  const handleAddNewOpen = useEvent(() => {
    setAddNewOpenedState(true);
  });

  const handleSubmit = useEvent((value: IStationHubItem) => {
    onAdded(value);
    handleAddNewClose();
  });

  return (
    <>
      {isAddNewOpened && (
        <StationHubItemEdit
          value={undefined}
          existingItems={existingItems}
          currentStationId={currentStationId}
          onCancel={handleAddNewClose}
          onSubmit={handleSubmit}
        />
      )}
      {!isAddNewOpened && (
        <Button
          type="button"
          size="medium"
          className="add_button"
          startIcon={<PlaylistAdd />}
          onClick={handleAddNewOpen}
        >
          {t("general.APPEND")}
        </Button>
      )}
    </>
  );
};
